export default "__VITE_ASSET__B9u$4u79__"